﻿'use strict';

angular.module('ntmApp').controller('RecurrenceController', ['$uibModalInstance', '$scope', 'data', 'Constants', 'DailyRecurrence', 'MonthlyRecurrence', 'WeeklyRecurrence', 'YearlyRecurrence', 'SharedRecurrence', 'SetupService', 'FlashService', 'ConfirmationService',
    function ($uibModalInstance, $scope, data, Constants, DailyRecurrence, MonthlyRecurrence, WeeklyRecurrence, YearlyRecurrence, SharedRecurrence, SetupService, FlashService, ConfirmationService) {

    var recurrences = [];
    var originalRecurrence = null;

    $scope.showWarningMessage = data.showWarningMessage;

    $scope.selectRecurrencePattern = function (pattern) {
            
        var recurrence = recurrences.firstOrDefault(function (recurr) {
            return parseInt(recurr.patternType) === pattern.value;
        });

        if (!recurrence) {
            recurrence = getRecurrenceByPattern(pattern.value);
            recurrence.applyDefaultInfo(data);
            recurrences.push(recurrence);
        }

        $scope.CurrentRecurrence = recurrence;
    };

    $scope.isPatternSelected = function (pattern) {

        if ($scope.CurrentRecurrence) {
            return parseInt($scope.CurrentRecurrence.patternType) === pattern.value;
        }

        return false;
    };

    $scope.showPattern = function (pattern) {
        if ($scope.CurrentRecurrence) {
            if (data.isSharedRecurrence) {
                return pattern.value !== Constants.Recurrence.Patterns.DAILY.value && pattern.value !== Constants.Recurrence.Patterns.SHARED.value;
            } else {
                return pattern.value !== Constants.Recurrence.Patterns.SHARED.value || data.showSharedTab;
            }
        }

        return false;
    };

    $scope.showDefaultOptions = function () {
        return !data.isSharedRecurrence;
    };

    $scope.isWhenOptionSelected = function (option) {

        if ($scope.CurrentRecurrence) {
            return parseInt($scope.CurrentRecurrence.whenOption) === option.value;
        }

        return false;
    };

    $scope.scheduleRacksOnDiffDays = function (schdeduleRacksOption) {
        if ($scope.CurrentRecurrence) {
            $scope.CurrentRecurrence.selectedSchdeduleRacksOption = schdeduleRacksOption; //temporary solution
            $scope.CurrentRecurrence.scheduleRacks = schdeduleRacksOption.value;
        }
    };

    $scope.isOccurenceWeeklyTypeSelected = function (occurenceWeeklyType) {

        if ($scope.CurrentRecurrence) {
            return occurenceWeeklyType.value === parseInt($scope.CurrentRecurrence.occurenceWeeklyType);
        }

        return false;
    };

    $scope.isOccurenceWeeklyTypeWithScheduledRacksSelected = function (occurenceWeeklyType) {

        if ($scope.CurrentRecurrence) {
            return occurenceWeeklyType.value === parseInt($scope.CurrentRecurrence.occurenceWeeklyTypeWithScheduledRacks);
        }

        return false;
    };

    $scope.isOccurenceYearlyTypeSelected = function (occurenceYearlyType) {

        if ($scope.CurrentRecurrence) {
            return occurenceYearlyType.value === parseInt($scope.CurrentRecurrence.occurenceYearlyType);
        }

        return false;
    };

    $scope.save = function () {
        if ($scope.CurrentRecurrence.areFieldsValid()) {
            //var loading = FlashService.Loading();

            SetupService.SaveRecurrenceData($scope.CurrentRecurrence.getRequestData()).then(function (result) {

                //loading.dismiss();

                if (result.success) {

                    FlashService.Success('Recurrence Successfully Saved');
                    $uibModalInstance.close(result.data.Recurrence);
                }

            });
        }
    };

    $scope.isRecurrenceChanged = function () {

        if (!$scope.CurrentRecurrence.equals(originalRecurrence)) {
            return true;
        }

        return false;
    };

    $scope.cancel = function () {

        if ($scope.CurrentRecurrence.patternType !== originalRecurrence.patternType) {
            $scope.selectRecurrencePattern({ value: parseInt(originalRecurrence.patternType) });
        }

        $scope.CurrentRecurrence.setOriginalValues(originalRecurrence);
    };

    $scope.close = function () {

        if (!$scope.isRecurrenceChanged()) {
            $uibModalInstance.close();
        } else {
            ConfirmationService.YesNoConfirmation("Save pending changes?", null, { no: 'No', yes: 'Yes' })
           .Yes($scope.save)
           .No(function () {
               $uibModalInstance.close();
           })
           .Ask();
        }
    };

    $scope.$on('modal.closing', function (event, reason) {
        switch (reason) {
            // clicked outside
            case "backdrop click":
                event.preventDefault();
                $scope.close(event);
                break;
            // escape key
            case "escape key press":
                event.preventDefault();
                $scope.close(event);
                break;
        }
    });

    function getRecurrenceByPattern(patternValue) {

        switch (parseInt(patternValue)) {
            case Constants.Recurrence.Patterns.DAILY.value:
                return new DailyRecurrence();
            case Constants.Recurrence.Patterns.WEEKLY.value:
                return new WeeklyRecurrence();
            case Constants.Recurrence.Patterns.MONTHLY.value:
                return new MonthlyRecurrence();
            case Constants.Recurrence.Patterns.YEARLY.value:
                return new YearlyRecurrence();
            case Constants.Recurrence.Patterns.SHARED.value:
                return new SharedRecurrence();
            default:
                 return new DailyRecurrence();
        }
    }

    function initialize() {

        $scope.todaysDate = moment().startOf('day');
        
        $scope.patterns = Constants.Recurrence.Patterns;
        $scope.whenOptions = Constants.Recurrence.WhenOptions;
        $scope.scheduleRacksOptions = Constants.Recurrence.ScheduleRacksOptions;
        $scope.isScheduleRack = data.isScheduleRack;

        $scope.daysOfWeek = Constants.DayLabels.labels;
        $scope.dayPrefixes = Constants.Recurrence.DayPrefixes;
        $scope.monthlyDays = Constants.Recurrence.MonthlyDays;
        $scope.months = Constants.Months;

        if (data.recurrenceId) {
            $scope.CurrentRecurrence = getRecurrenceByPattern(data.patternType);
            $scope.CurrentRecurrence.applyRecurrenceInfo(data);
        } else {
            $scope.CurrentRecurrence = data.isSharedRecurrence ? new WeeklyRecurrence() : new DailyRecurrence();
            $scope.CurrentRecurrence.applyDefaultInfo(data);
        }

        $scope.dialogName = data.dialogName;

        recurrences.push($scope.CurrentRecurrence);
        originalRecurrence = angular.copy($scope.CurrentRecurrence);
    }

    initialize();

}]);
